import React, { useEffect, useState } from 'react';
import SidebarLink from '../Layout/sidebar/SidebarLink';
import { fetchEntrataTestProperties } from './qaToolsApi';

// The tools exist only on QA and local; everywhere else the API answers 404 and the link
// stays hidden instead of leading to an unavailable page.
const QaToolsSidebarLink = () => {
  const [isAvailable, setAvailable] = useState(false);

  useEffect(() => {
    let isMounted = true;
    fetchEntrataTestProperties().then(result => {
      if (isMounted) {
        setAvailable(result.available);
      }
    });

    return () => { isMounted = false; };
  }, []);

  return isAvailable ? <SidebarLink title="QA Tools" route="/qa-tools" /> : null;
};

export default QaToolsSidebarLink;
